export default __webpack_public_path__ + "static/media/PipetteVector.7143e5c2.svg";